import { render, staticRenderFns } from "./flXsjlTarget.vue?vue&type=template&id=a23336aa"
import script from "./flXsjlTarget.vue?vue&type=script&lang=js"
export * from "./flXsjlTarget.vue?vue&type=script&lang=js"
import style0 from "./flXsjlTarget.vue?vue&type=style&index=0&id=a23336aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports